import { render } from "./SignUp.vue?vue&type=template&id=68e12791&scoped=true"
import script from "./SignUp.vue?vue&type=script&lang=js"
export * from "./SignUp.vue?vue&type=script&lang=js"

import "../../assets/css/Main.css?vue&type=style&index=0&id=68e12791&scoped=true&lang=css&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68e12791"]])

export default __exports__